__turbopack_context__.v({
  "fieldset": "IsZWpW_fieldset",
  "legend": "IsZWpW_legend",
});
